/*
 *
 * Communications reducer
 *
 */
import produce from "immer";

import { notification } from "antd";

import {
  FLUSH_STATE_COMMUNICATIONS,
  INITIAL_ID,
  // load items list
  LOAD_COMMUNICATIONS,
  LOAD_COMMUNICATIONS_SUCCESS,
  LOAD_COMMUNICATIONS_ERROR,
  // load single item
  LOAD_COMMUNICATION,
  LOAD_COMMUNICATION_SUCCESS,
  LOAD_COMMUNICATION_ERROR,
  // load single item answers
  LOAD_COMMUNICATION_ANSWERS,
  LOAD_COMMUNICATION_ANSWERS_SUCCESS,
  LOAD_COMMUNICATION_ANSWERS_ERROR,
  // update single item answers
  UPDATE_COMMUNICATION_ANSWERS,
  UPDATE_COMMUNICATION_ANSWERS_SUCCESS,
  UPDATE_COMMUNICATION_ANSWERS_ERROR,
  // update item
  UPDATE_COMMUNICATION,
  UPDATE_COMMUNICATION_SUCCESS,
  UPDATE_COMMUNICATION_ERROR,
  // delete item
  HARD_DELETE_COMMUNICATION,
  HARD_DELETE_COMMUNICATION_SUCCESS,
  HARD_DELETE_COMMUNICATION_ERROR,
  // copy item
  COPY_COMMUNICATION,
  COPY_COMMUNICATION_SUCCESS,
  COPY_COMMUNICATION_ERROR,
  // Update ACtive Communication
  UPDATE_ACTIVE_COMMUNICATION,
  UPDATE_ACTIVE_COMMUNICATION_SUCCESS,
} from "./constants";

export const initialState = {
  initialID: null,
  firstRender: true,
  loading: true,
  error: false,
  firstElem: false,
  activeElement: false,
  actionType: "read",
  itemsList: [],
  allData: false,
  pages: 1,
  currentPage: 1,
  totalAmount: 0,
  // load detail item
  detailID: null,
  loadDetail: false,
  errorDetail: false,
  // load detail item answers
  detailID: null,
  loadAnswers: true,
  errorAnswers: false,
  answers: {},
  // update detail item answers
  planArray: [],
  commID: null,
  planData: [],
  actionType: "save",
  answerType: "appointments",
  updatePlanSuccessful: false,
  updatePlan: false,
  errorPlan: false,
  // update
  itemDetail: false,
  isNew: false,
  isNewSuccessful: false,
  updateSuccessful: false,
  loadingUpdate: false,
  errorUpdate: false,
  // hard Delete
  hardDeleteId: null,
  hardDeleteDetail: false,
  hardDeleteSuccessful: false,
  hardDeleteLoading: false,
  hardDeleteError: false,
  // copy item
  toCopyID: null,
  copySuccessful: false,
  copyLoading: false,
  copyError: false,
  // filter list
  params: {
    page: 1,
    limit: 10,
    searchStr: "",
    filterValue: [],
  },
  filtering: false,
  sameParams: false,
  noMore: false,
};

import { getUniqueArrayObj, getObjId } from "utils/helpers/helper.general";

/* eslint-disable default-case, no-param-reassign */
const communicationsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_COMMUNICATIONS:
        return initialState;

      case INITIAL_ID:
        draft.initialID = action.initialID;
        if (action.initialID == "new") {
          draft.toCopyID = null;
          draft.commID = null;
          draft.hardDeleteId = null;
          draft.itemDetail = false;
          draft.loadDetail = false;
          draft.errorDetail = false;
        } else {
          draft.loadDetail = true;
        }
        break;

      // LOAD
      case LOAD_COMMUNICATIONS:
        draft.firstRender = action.firstRender;
        draft.pages = action.pages;
        draft.loading = true;
        draft.error = false;

        if (
          !state?.firstRender &&
          (state?.params?.searchStr != action?.params?.searchStr ||
            JSON.stringify(state?.params?.filterValue) !=
              JSON.stringify(action?.params?.filterValue))
        ) {
          draft.filtering = true;
          draft.params = {
            ...action.params,
            page: 1,
          };
          draft.noMore = false;
        } else {
          draft.filtering = false;
          draft.params = action.params;
        }
        break;
      case LOAD_COMMUNICATIONS_SUCCESS:
        draft.loading = false;
        draft.allData = action.allData;
        draft.totalAmount = action.allData?.totalAmount || 0;
        draft.pages = action.allData?.pages || 1;
        draft.currentPage = action.allData?.currentPage || 1;

        if (action.itemsList?.length > 0) {
          if (action.allData?.currentPage == 1) {
            draft.itemsList = action.itemsList;
            draft.noMore = false;

            if (state?.firstRender && state.initialID !== "new") {
              draft.firstElem = action.itemsList[0] || null;
              draft.initialID =
                state.initialID || action.itemsList[0]?._id || null;
            } else if (!state?.firstRender && state.initialID == "new") {
              draft.firstElem = action.itemsList[0] || null;
            } else if (!state?.firstRender && state.initialID !== "new") {
              const newArr = action.itemsList;
              const hasItem = newArr.some(el => el?._id == state.initialID);
              const currentItem = newArr.filter(
                el => el?._id == state.initialID,
              );

              if (!hasItem) {
                draft.firstElem = action.itemsList[0] || null;
                draft.initialID = action.itemsList[0]?._id || null;
              } else if (hasItem && currentItem) {
                draft.firstElem = currentItem || null;
              }
            }
          } else {
            let listData = state.itemsList;
            const newListTemp = listData.concat(action.itemsList);
            const newList = getUniqueArrayObj(newListTemp, "_id");
            draft.itemsList = newList;
          }
        } else {
          let listData = state.itemsList;
          if (action.allData?.currentPage == 1) {
            draft.itemsList = action.itemsList;
            draft.noMore = false;
          } else {
            const newListTemp = listData.concat(action.itemsList);
            const newList = getUniqueArrayObj(newListTemp, "_id");
            draft.itemsList = newList;
          }
        }

        // set No More action
        if (action.allData?.currentPage == action.allData?.pages) {
          draft.noMore = true;
        }

        break;

      case LOAD_COMMUNICATIONS_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.firstRender = false;
        draft.firstElem = false;
        draft.activeElement = false;
        break;

      case UPDATE_ACTIVE_COMMUNICATION:
        const newACtiveEl = {
          ...state.activeElement,
          ...action.activeElement,
        };
        draft.activeElement = newACtiveEl;
        draft.actionType = action.actionType;
        // update single item in the list inside state
        let listData = draft.itemsList;
        let index = draft.itemsList.findIndex(
          po => getObjId(po) === getObjId(newACtiveEl),
        );
        if (index !== -1 && typeof newACtiveEl == "object") {
          listData[index] = newACtiveEl;
          // result
          draft.itemsList = listData;
          draft.allData = {
            ...state.allData,
            data: listData,
          };
        }
        break;

      // LOAD DETAIL
      case LOAD_COMMUNICATION:
        draft.loadDetail = true;
        draft.errorDetail = false;
        draft.isNew = false;
        draft.isNewSuccessful = false;
        draft.loadingUpdate = false;
        draft.updateSuccessful = false;
        draft.hardDeleteLoading = false;
        draft.hardDeleteSuccessful = false;
        draft.copyLoading = false;
        draft.copySuccessful = false;
        draft.answers = {};
        draft.detailID = action.detailID;
        break;

      case LOAD_COMMUNICATION_SUCCESS:
        draft.itemDetail = action.itemDetail;
        draft.activeElement = {
          ...action.activeElement,
          ...action.itemDetail,
        };
        draft.loadDetail = false;
        break;

      case LOAD_COMMUNICATION_ERROR:
        draft.errorDetail = action.errorDetail;
        draft.loadDetail = false;
        break;

      // LOAD DETAIL ANSWERS
      case LOAD_COMMUNICATION_ANSWERS:
        draft.loadAnswers = true;
        draft.errorAnswers = false;
        draft.isNew = false;
        draft.isNewSuccessful = false;
        draft.loadingUpdate = false;
        draft.updateSuccessful = false;
        draft.hardDeleteLoading = false;
        draft.hardDeleteSuccessful = false;
        draft.copyLoading = false;
        draft.copySuccessful = false;
        draft.detailID = action.detailID;
        break;

      case LOAD_COMMUNICATION_ANSWERS_SUCCESS:
        draft.loadAnswers = false;
        const { answers } = action;
        if (!!answers && Object.keys(answers)?.length > 0) {
          draft.errorAnswers = false;
          draft.answers = action.answers;
        } else {
          draft.errorAnswers = true;
        }
        break;

      case LOAD_COMMUNICATION_ANSWERS_ERROR:
        draft.errorAnswers = action.errorDetail;
        draft.loadAnswers = false;
        break;

      // UPDATE DETAIL ANSWERS
      case UPDATE_COMMUNICATION_ANSWERS:
        draft.updatePlan = true;
        draft.updatePlanSuccessful = false;
        draft.errorPlan = false;
        draft.loadAnswers = false;
        draft.errorAnswers = false;
        draft.isNew = false;
        draft.isNewSuccessful = false;
        draft.loadingUpdate = false;
        draft.updateSuccessful = false;
        draft.hardDeleteLoading = false;
        draft.hardDeleteSuccessful = false;
        draft.copyLoading = false;
        draft.copySuccessful = false;
        draft.commID = action.commID;
        draft.planArray = action.planArray;
        draft.actionType = action.actionType;
        draft.answerType = action.answerType;
        break;

      case UPDATE_COMMUNICATION_ANSWERS_SUCCESS:
        draft.updatePlan = false;
        draft.updatePlanSuccessful = true;
        draft.errorPlan = false;
        draft.planData = action.planData;
        break;

      case UPDATE_COMMUNICATION_ANSWERS_ERROR:
        draft.errorPlan = action.errorPlan;
        draft.updatePlan = false;
        draft.updatePlanSuccessful = false;
        break;

      // CHANGE/UPDATE for Single Element
      case UPDATE_COMMUNICATION:
        draft.loadingUpdate = true;
        draft.error = false;
        draft.errorUpdate = false;
        draft.itemDetail = {
          ...state.itemDetail,
          ...action.itemDetail
        };
        draft.isNewSuccessful = false;
        draft.updateSuccessful = false;
        draft.hardDeleteLoading = false;
        draft.hardDeleteSuccessful = false;
        draft.copyLoading = false;
        draft.copySuccessful = false;
        draft.isNew = false;
        if (!!!action.itemDetail?._id) {
          draft.isNew = true;
        }
        break;
      case UPDATE_COMMUNICATION_SUCCESS:
        draft.loadingUpdate = false;
        const { itemDetail } = action;
        if (itemDetail?._id) {
          if (state.isNew || !!!state.itemDetail?._id) {
            draft.totalAmount = Number(state.totalAmount) + 1;
            draft.isNewSuccessful = true;
            draft.updateSuccessful = false;
          } else {
            draft.isNewSuccessful = false;
            draft.updateSuccessful = true;
          }

          draft.itemDetail = itemDetail;
          draft.errorUpdate = false;

          // update single item in the list inside state
          let listData = draft.itemsList;
          let index = draft.itemsList.findIndex(
            po => po._id === itemDetail._id,
          );

          index !== -1
            ? (listData[index] = itemDetail)
            : listData.unshift(itemDetail);

          // result
          draft.itemsList = listData;
          draft.allData = {
            ...state.allData,
            data: listData,
          };
        } else {
          draft.itemDetail = false;
          if (itemDetail?.code == 500) {
            console.error("error 500:", { itemDetail });
            draft.errorUpdate = itemDetail?.message;
          } else if (itemDetail?.code == 200) {
            draft.errorUpdate = itemDetail?.message;
          }
        }

        break;
      case UPDATE_COMMUNICATION_ERROR:
        draft.errorUpdate = action.errorUpdate;
        draft.loadingUpdate = false;
        draft.isNew = false;
        draft.isNewSuccessful = false;
        draft.updateSuccessful = false;
        break;

      // HARD DELETE for Single Element
      case HARD_DELETE_COMMUNICATION:
        draft.hardDeleteId = action.hardDeleteId;
        draft.hardDeleteLoading = true;
        draft.hardDeleteError = false;
        draft.isNew = false;
        draft.isNewSuccessful = false;
        draft.loadingUpdate = false;
        draft.updateSuccessful = false;
        draft.hardDeleteSuccessful = false;
        draft.copyLoading = false;
        draft.copySuccessful = false;
        break;
      case HARD_DELETE_COMMUNICATION_SUCCESS:
        draft.hardDeleteLoading = false;
        draft.hardDeleteError = false;
        draft.hardDeleteDetail = action.hardDeleteDetail;
        draft.hardDeleteId = action.hardDeleteId;

        if (action.hardDeleteDetail && action.hardDeleteId) {
          draft.hardDeleteSuccessful = true;

          let listData = draft.itemsList;
          const index = draft.itemsList.findIndex(
            po => po._id == action.hardDeleteId,
          );
          //const deletedItem = listData[index];
          if (index !== -1) {
            listData.splice(index, 1);
            draft.totalAmount = Number(state.totalAmount) - 1;
          }

          // result
          draft.itemsList = listData;
          draft.allData = {
            ...state.allData,
            data: listData,
          };

          if (state.initialID == action.hardDeleteId) {
            draft.firstElem = listData[0] || null;
            draft.activeElement = listData[0] || null;
            draft.initialID = listData[0]?._id || null;
          }
        }

        break;
      case HARD_DELETE_COMMUNICATION_ERROR:
        draft.hardDeleteError = action.hardDeleteError;
        draft.hardDeleteLoading = false;
        draft.hardDeleteSuccessful = false;
        break;

      // COPY
      case COPY_COMMUNICATION:
        draft.toCopyID = action.toCopyID;
        draft.copyLoading = true;
        draft.copySuccessful = false;
        draft.copyError = false;
        draft.isNew = false;
        draft.isNewSuccessful = false;
        draft.loadingUpdate = false;
        draft.updateSuccessful = false;
        draft.hardDeleteLoading = false;
        draft.hardDeleteSuccessful = false;
        break;
      case COPY_COMMUNICATION_SUCCESS:
        draft.copyLoading = false;
        draft.copyError = false;

        if (action.itemDetail?._id) {
          draft.totalAmount = Number(state.totalAmount) + 1;
          // draft.itemDetail = action.itemDetail;
          draft.copySuccessful = true;

          // update single item in the list inside state
          let listData = draft.itemsList;
          listData.unshift(action.itemDetail);

          // result
          draft.itemsList = listData;
          draft.allData = {
            ...state.allData,
            data: listData,
          };
        }
        break;
      case COPY_COMMUNICATION_ERROR:
        draft.copyError = action.copyError;
        draft.copyLoading = false;
        draft.toCopyID = null;
        break;
    }
  });

export default communicationsReducer;
